/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Gym_TwoInputs */

const en_features_gym_two = /** @type {(inputs: Features_Gym_TwoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Old Town Club`)
};

const pl_features_gym_two = /** @type {(inputs: Features_Gym_TwoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klub Stare Miasto`)
};

/**
* | output |
* | --- |
* | "Old Town Club" |
*
* @param {Features_Gym_TwoInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_gym_two = /** @type {((inputs?: Features_Gym_TwoInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Gym_TwoInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_gym_two(inputs)
	return en_features_gym_two(inputs)
});